import is from '@sindresorhus/is';

import {
    and,
    between,
    contains,
    equals,
    greaterOrEqual,
    isIn,
    lessOrEqual,
} from '../../../../../shared/source/data-contract/filter';

import type { GeneralFilter } from '../../../../../shared/source/data-contract/filter';
import type { FilterState } from '../../../../../shared/source/data-contract/filter-state';

// eslint-disable-next-line complexity
export const convertFilterStateToFilters = (filterStates: readonly FilterState[]): GeneralFilter | undefined => {
    const filters = new Set<GeneralFilter>();

    for (const filterState of filterStates) {
        const { field, type, value } = filterState;

        if (type === 'boolean') {
            if (is.boolean(value)) {
                filters.add(equals(field, value));
            }
        }

        if (type === 'date' && is.nonEmptyArray(value)) {
            const [start, end] = value;

            if (is.date(start) && is.date(end)) {
                filters.add(between(field, start.toISOString(), end.toISOString()));
            } else if (is.date(start)) {
                filters.add(greaterOrEqual(field, start.toISOString()));
            } else if (is.date(end)) {
                filters.add(lessOrEqual(field, end.toISOString()));
            }
        }

        if (type === 'skill' && is.nonEmptyArray(value)) {
            filters.add(isIn(field, value));
        }

        if (type === 'search' && is.nonEmptyArray(value)) {
            filters.add(contains(field, value[0], true));
        }

        if (type === 'percent' && is.nonEmptyArray(value)) {
            filters.add(between(field, value[0], value[1]));
        }

        if (
            (type === 'integer' || type === 'state' || type === 'string' || type === 'user') &&
            is.nonEmptyArray(value)
        ) {
            filters.add(isIn(field, value));
        }
    }

    return filters.size > 0 ? and(...filters.values()) : undefined;
};
